import { Component, Input, OnInit } from "@angular/core";
import { OffcanvasOptions } from "@app/core/_base/layout";

@Component({
	selector: "kt-sticky-side-menu",
	templateUrl: "./sticky-side-menu.component.html",
	styleUrls: ["./sticky-side-menu.component.scss"],
})
export class StickySideMenuComponent implements OnInit {
	xname: string = "";
	close: string = "";
	toggle: string = "";

	panelOptions: OffcanvasOptions;

	@Input() set pname(value: string) {
		if (value) {
			this.xname = value;

			this.close = this.xname + "_close";
			this.toggle = this.xname; //+ '_toggle';
		}
	}

	@Input()
	title: string = "";

	constructor() {}

	ngOnInit() {
		this.panelOptions = {
			overlay: true,
			baseClass: "kt-demo-panel",
			closeBy: this.close,
			toggleBy: this.toggle,
		};
	}

  
}
